import { render } from "./ShoppingListRecommendationList.vue?vue&type=template&id=3439db10&scoped=true&ts=true"
import script from "./ShoppingListRecommendationList.vue?vue&type=script&lang=ts"
export * from "./ShoppingListRecommendationList.vue?vue&type=script&lang=ts"

import "./ShoppingListRecommendationList.vue?vue&type=style&index=0&id=3439db10&lang=scss&scoped=true"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3439db10"]])

export default __exports__